import React from 'react';
import Styles from './Contact.module.scss';
import HomeStyles from '../home/Home.module.scss';
import classnames from "classnames";
import imageLink from "../../images/smooth_profile.png";
import avatar from "../images/form_me_error.png";
import { SocialMedia } from '../../../src/constants/social_media';

interface ContactProps {
    theme: string;
    backgroundImageUrl: string;
}
const Contact = ({ theme, backgroundImageUrl }: ContactProps) => {

    
  const openTab=(link:string)=>{
    window.open(link, '_blank', 'noopener,noreferrer');
  }
  

    return (
                <div className={Styles.social_media}>
                    <div className={Styles.heading_text}>
                        Social media 
                    </div>
                    <div className={Styles.social_media_links}>
                        
                {
                    SocialMedia.map((social: any,index : number) => {
                        return (

                            <a className={Styles.platform_tile} href={social.link} target="_blank" key={index}>
                                <div className={Styles.icon_container}>
                                    <img src={social.icon} />
                                </div>
                                <div className={Styles.title}>
                                    {social.label}</div>
                            </a>
                        )
                    })
                }
                    </div>
                </div>


    )
}

export default Contact;

